import { Ability } from '@casl/ability'
import store from '@/store/store'

export default new Ability(store.state.auth.abilities)
